"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Inverts a promise.
 * Resolved will be converted to rejected.
 * Rejected will be converted to resolved.
 *
 * @example
 *
 * const callWeiredApi = (args) => Promise.resolve()
 *  .then(invert(() => fetch('something/weired'));
 */
var invert = exports.invert = function invert(fn) {
  return function (args) {
    return Promise.resolve().then(function () {
      return fn(args);
    }).then(function (value) {
      throw value;
    }, function (error) {
      return error;
    });
  };
};